import { useEffect } from 'react';
import { useAuthStore } from '@/shared/stores/auth';
import { useLiveCall } from '../stores/liveCall';

/**
 * מפעיל את מעקב השיחה החי (SSE + polling) כל עוד הנציג מחובר.
 * רץ גם בטאב ברקע — שיחה שהגיעה בזמן שהטאב לא היה בפוקוס חייבת להופיע
 * ברגע שחוזרים אליו, בלי לחכות לסבב הבא.
 */
export function useAgentLive(): void {
  const token = useAuthStore((s) => s.token);
  const persona = useAuthStore((s) => s.persona);

  useEffect(() => {
    if (!token || persona !== 'agent') return;
    useLiveCall.getState().start();
    const onVisible = () => {
      if (!document.hidden) void useLiveCall.getState().refresh();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      document.removeEventListener('visibilitychange', onVisible);
      useLiveCall.getState().stop();
    };
  }, [token, persona]);
}
